
export default {
  name: 'AdvVertical',
  props: {
    advertising: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getImage(advertising) {
      const image = advertising.advertisingType.cptAdv.cptAdvImage
      return image
    },
  },
}
